import React from 'react';
import AdminAiLogsPage from '../components/AdminAiLogs/AdminAiLogsPage';

const AdminAiLogs = () => <AdminAiLogsPage />;

export default AdminAiLogs;
